import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { TwilioCampaignHttpResponse } from 'types/twilio/twilioCampaign';
import { getTwilioCampaign } from 'api/admin/businesses/twilioIntegration';
import { TwilioQueryKeys } from 'constants/twilio/twilioQueryKeys';

export const useGetTwilioCampaign = ({
  businessId,
  campaignId,
  messagingServiceId,
}: {
  businessId: number;
  campaignId: string | null | undefined;
  messagingServiceId: string | null | undefined;
}) => {
  const { isLoading, error, data, refetch } = useQuery<
    unknown,
    AxiosError<{ error: string }>,
    TwilioCampaignHttpResponse
  >({
    queryKey: [TwilioQueryKeys.CAMPAIGN, businessId],
    queryFn: async () => {
      const response = await getTwilioCampaign({
        businessId,
        campaignId: campaignId!,
        messagingServiceId: messagingServiceId!,
      });

      return response.data;
    },
    enabled: !!messagingServiceId && !!campaignId,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(error?.response?.data?.error ?? 'An error occurred while fetching Twilio campaign', {
        icon: '❌',
      });
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
